export enum DeviceBreakpointsEnum {
  Mobile = 767,
}
